import React, { useState } from "react";
import Tabs from "../../CommonComponents/Tabs";
import Filters from "./Filterbtn";
import Table from "./Table";
import Pagination from "./Pagination";
import { useRollId } from "../../CommonComponents/RollIdContext";
import "./Table.css";

const MainContent = ({ reload }) => {
  const [filters, setFilters] = useState({
    date: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTP] = useState(0);
  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <div className="flex-grow-1 d-flex flex-column pt-2">
        <div className="mt-2">
          <Filters filters={filters} setFilters={setFilters} />
        </div>
        <div className="table-wrapper marginRight flex-grow-1 p-3 rounded shadow-sm d-flex flex-column hgo-table-wrapper">
          <div
            className="table-container overflow-auto flex-grow-1 hgo-table-container"
          >
            <Table
              reload={reload}
              filters={filters}
              setTotalPages={setTP}
              page={page}
              setPage={setPage}
            />
          </div>
          <div className="d-flex justify-content-end mt-5 me-3">
            <Pagination totalPages={totalPages} page={page} setPage={setPage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
